import { NatObjectItemController } from "@natiwi/core/controllers/object-item.controller";
import { OrmCustomerOrderProductItem } from "@natiwi/shared/models/customer-order.model";

export class NatCustomerOrderProductItemController extends NatObjectItemController<OrmCustomerOrderProductItem>{

    constructor() {
        super();
        super.registerDataClass(OrmCustomerOrderProductItem);
    }
}